import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedFilter from '../../Components/AdvancedFilter'
import AdvancedTable from '../../Components/AdvancedTable'
import FormCreate from '../../Containers/Banner/FormCreate'
import UpdateContent from '../../Containers/Banner/UpdateContent'
import UpdateImage from '../../Containers/Banner/UpdateImage'
import BannerActions from '../../Redux/BannerRedux'
import Toggle from 'react-toggle'
import filterData from './filterData.json'

class Banners extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      filter: {
        title: '',
        iso_code: ''
      },
      detail: {}
    }
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchBanner()
    }
  }

  _handleToggle = (item) => {
    let status
    if (item.status === 'active') {
      status = 'inactive'
    } else if (item.status === 'inactive') {
      status = 'active'
    }
    let data = {
      id: item.id,
      form: {
        iso_code: item.iso_code,
        status
      }
    }
    this.props.updateBanner(data)
    setTimeout(() => {
      this._fetchBanner()
    }, 300)
  }

  componentDidMount () {
    this._fetchBanner()
  }

  _fetchBanner = (event) => {
    if (event) { event.preventDefault() }
    let data = this.state.filter
    this.props.getBanners(data)
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _delete = () => {
    this.props.deleteBanner(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _manipulateState = (props) => {
    this.setState({ filter: props })
  }

  render () {
    const { banner } = this.props
    return (
      <section className='section'>

        <header>
          <div className='title-block d-flex mb-3'>
            <h3 className='title mr-auto'>
              Banner List
              {
                banner.fetching &&
                <div className='badge badge-info ml-2'>Loading ...</div>
              }
            </h3>
            <button className='btn btn-primary ml-auto' onClick={() => this._toggleModal('create')}>Register New Banner</button>
          </div>
          <div className='title-block'>
            <AdvancedFilter
              filters={filterData.bannerFilters}
              manipulateState={(props) => this._manipulateState(props)}
              callback={(event) => this._fetchBanner(event)}
            />
          </div>
        </header>

        <section className='section'>
          <div className='card'>
            {
              !(banner.fetching || banner.processing) && banner.err &&
              <div className='alert alert-danger'>{banner.err}</div>
            }
            <AdvancedTable
              colSpan={9}
              header={[
                { field: 'Title', className: 'text-left' },
                { field: 'Origin' },
                { field: 'Priority' },
                { field: 'Status' },
                { field: 'Web' },
                { field: 'Mobile' },
                { field: 'Update', colSpan: 2 },
                { field: 'Delete' }
              ]}
              body={
                banner.data &&
                banner.data.length > 0 &&
                banner.data.map(item => ([
                  { field: item.title, className: 'text-left' },
                  { field: item.iso_code },
                  { field: item.priority },
                  {
                    field: <Toggle checked={item.status === 'active'} onChange={() => this._handleToggle(item)} />
                  },
                  {
                    field:
                      item.image_url.web
                        ? <img src={item.image_url.web} alt='' className='img img-responsive' height='65px' />
                        : '- No Image -'
                  },
                  {
                    field:
                      item.image_url.mobile
                        ? <img src={item.image_url.mobile} alt='' className='img img-responsive' height='65px' />
                        : '- No Image -'
                  },
                  {
                    field: <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-content')}>
                      <i className='fa fa-edit' /> Content
                    </button>
                  },
                  {
                    field: <button className='btn btn-info mr-2' onClick={() => this._selectItem(item, 'edit-image')}>
                      <i className='fa fa-image' />Image
                    </button>
                  },
                  {
                    field: <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete')}>
                      <i className='fa fa-trash' />
                    </button>
                  }
                ]))
              }
            />
          </div>

          {/* CREATE */}
          <Modal center open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormCreate closeModal={() => this._toggleModal()} />
          </Modal>

          {/* EDIT CONTENT */}
          <Modal center open={this.state.showModal === 'edit-content'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateContent detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* EDIT IMAGE */}
          <Modal center open={this.state.showModal === 'edit-image'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* DELETE */}
          <Modal center open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
            <section className='section' style={{ width: '40vw' }}>
              <div className='title-block'>
                <h3>Delete Banner?</h3>
              </div>
              <div className='text-center'>
                <h4>
                  { this.state.detail.title || '-' }
                </h4>
              </div>
              <div className='text-center'>
                <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
                <button className='btn btn-lg btn-danger' onClick={() => this._delete()}>Delete</button>
              </div>
            </section>
          </Modal>

        </section>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  banner: state.banner
})

const dispatchToProps = (dispatch) => ({
  getBanners: (filter) => dispatch(BannerActions.bannerRequest(filter)),
  deleteBanner: (id) => dispatch(BannerActions.bannerDeleteRequest({ id })),
  updateBanner: (data) => dispatch(BannerActions.bannerUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(Banners)



// WEBPACK FOOTER //
// ./src/Pages/Misc/Banners.js